import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { Resources } from 'src/app/models/maintenance/resources';
import { Notification } from 'src/app/models/notification/notification';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HandlerItemsSource } from 'src/app/components/shared/handler-items/handler-items.component';
import { HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';

@Component({
    selector: 'app-details-purchase-order',
    templateUrl: './details-purchase-order.component.html',
    styleUrls: ['./details-purchase-order.component.scss'],
    standalone: false
})
export class DetailsPurchaseOrderComponent implements OnInit {

  public HandlerItemsSource = HandlerItemsSource;
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Almacén Orden Compra",
      router: '/almacen/orden_compra',
    },
    {
      name: "Detalle",
      current: true
    }
  ]

  private urlCrudPurschaseOrder: string = `${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}`;
  public urlGetItemsWarehouse: string = `${EndpointDictionary.Item.ITEM_COMBO_WAREHOUSE}`;

  public purchaseOrderData: Array<HistoryInventory> = []
  public formPO: UntypedFormGroup
  public redirectionType: string
  public historyInventoryData: HistoryInventory
  public resourcesData: Array<Resources>
  public view: boolean = true

  constructor(
    public http: HttpService,
    private message: MessageService,
    public router: Router,
    private session: SessionService,
    private notificationService: NotificationsService,
    private storage: LocalStorageService,
    private generatePdf: GeneratePdfFosilService
  ) { }

  async ngOnInit() {
    this.historyInventoryData = this.session.getData('purchaseOrder')
    if(this.historyInventoryData.stateId && this.historyInventoryData.stateId !== 1){
      this.view = false
    }
    this.getResourcespurchaseOrder()
  }
  ngOnDestroy(){
    this.session.setData('purchaseOrder', null)
    this.session.setData('purchaseOrderData',null)
  }



  async savePurchaseOrder($event: HistoryInventory) {
    this.message.openLoading("Cargando", "Guardando Orden de Compra")
    let res = null
    if($event.id) {
      delete $event.date
      delete $event.userId
      delete $event.orderId
      delete $event.purchaseOrderId
      delete $event.rentalorderId
      res = await this.http.putDataBody<GenericResponse>(this.urlCrudPurschaseOrder, $event)
    }
    else{
      delete $event.rentalorderId
      res = await this.http.postDataBody<GenericResponse>(this.urlCrudPurschaseOrder, $event)
    }
    if (res) {
      let notification: Notification[] = [{ notified: this.historyInventoryData.authorize, companyId: this.storage.get<number>('companyId')}];      
        this.notificationService.emitUpdateNotificationsByNotifications(notification)
     
      this.message.closeLoading()
      this.message.SuccessToast("Ordenes de Compra guardadas correctamente")

      setTimeout(() => {
        this.router.navigate(['/almacen/orden_compra'])
      }, 500);
    }
  }

  async getResourcespurchaseOrder(){
    var resources = this.session.getData('purchaseOrderData')
    if (resources && resources.length > 0)  this.purchaseOrderData = resources
  }

  async printPurchaseOrder(id: number){
    this.generatePdf.generatePurchaseOrderPDF(id);
  }


}
